import axios from 'axios';
import { domain } from './domain'

export const getCompanyById = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    }
    return axios(`${domain}/company/getbyid`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}


export const updateCompany = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateCompanyLogo = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company/logo`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateCompanyFiles = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company/files`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateCompanyGallery = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company/gallery`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const updateCompanyCertificates = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company/certificates`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const createAggreement = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    }
    return axios(`${domain}/company/aggreement`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}

export const getAggreement = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    }
    return axios(`${domain}/company/getaggreement`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}

export const createBanner = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    }
    return axios(`${domain}/company/banner`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}

export const getBanners = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
        data
    }
    return axios(`${domain}/company/getbanners`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}


export const createBannerImage = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        },
        data,
    };
    return axios(`${domain}/company/bannerimage`, requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch((error) => {
            return error;
        });
};

export const deleteBanner = (token, data) => {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data
    }
    return axios(`${domain}/company/banner`, requestOptions)
        .then(response => {
            if (response.data.code) {
                return response
            }
            throw new Error('Bağlantı hatası!');
        })
        .catch(error => { return error })
}